import React, { useEffect, useRef, useState } from "react";
import IndexNavbar from "components/Navbars/IndexNavbar";
import FooterSmallNew from "components/Footers/FooterSmallNew";
import daurade from "assets/img/fish/daurade.b90d4aeab56eafe87075.webp";
import maigre from "assets/img/fish/maigre.png";
import octopus from "assets/img/fish/octopus.1dffb132e82b127bfbbd.webp";
import scorpion from "assets/img/fish/scorpion.e344b4934e52ae09bc5c.webp";
import spottedshark from "assets/img/fish/spottedshark.1cc709fc36c58411231e.webp";
import cuttlefish from "assets/img/fish/cuttlefish.2d6b5243d5619807e8ce.webp";
import redmullet from "assets/img/fish/redmullet.6798065c843c1429e388.webp";
import pargo from "assets/img/fish/pargo.e8d47de5ad2330fc77b0.webp";
import scorpaena from "assets/img/fish/scorpaena.4dd26b1bfa43dbc19732.webp";
import squid1 from "assets/img/fish/squid1.15f35892862271058a65.webp";
import mero from "assets/img/fish/mero.0017d2bcff4c9949352b.webp";
import squid from "assets/img/fish/squid.cc9095ee3226c9b26b71.webp";
import bonito1 from "assets/img/fish/bonito1.19312055660926c08276.webp";
import bluefinggloins from "assets/img/fish/bluefinggloins.d261aeca6a74b6c3d22e.webp";
import bluefingg from "assets/img/fish/bluefingg.webp";
import swordfish from "assets/img/fish/swordfish.ce6dd6320275678e44d3.webp";
import pilchard from "assets/img/fish/pilchard.29e41a93a786e9a0ce39.webp";
import whitegrouper1 from "assets/img/fish/whitegrouper1.71fee22c3d63d4ef7529.webp";
import greymullet from "assets/img/fish/greymullet.0a34eaafe4ebb158034b.webp";
import thon from "assets/img/fish/thon.882d7a06536a71892c1e.webp";
import loup from "assets/img/fish/loup.246ce51bf801f346838f.webp";
import mottledgrouper3 from "assets/img/fish/mottledgrouper3.193dce45a223f0a7a635.webp";
import shrimp1 from "assets/img/fish/shrimp1.2013c45369484e143e46.webp";
import Footer from "components/Footers/Footer";
import bghome from "assets/img/bghome.jpg";
import IndexNavbar2 from "components/Navbars/IndexNavbar2";
import menu from "assets/img/menu.jpg";
import { useTranslation } from "react-i18next";
import { useLanguage } from "components/Homepage/LanguageContext";

const FoodMenu = () => {
  const { t } = useTranslation();
  const { changeLanguage } = useLanguage();
  return (
    <section>
      <IndexNavbar2 />
      <section className="xl:pt-28 lg:pt-28 md:pt-17 pt-17"></section>
      <section
        style={{
          position: "relative",
          backgroundImage: `url(${menu})`,
          width: "100%",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        className="xl:h-450 lg:h-300 md:h-300 justify-center text-white"
      >
        <div className="">
          <div className="container mx-auto overflow-hidden hometext xl:px-24 px-4">
            <div className="grid md:grid-cols-2 ">
              <div className="text-left bg-dark-blue xl:p-16 lg:p-14 md:p-12 p-12">
                <h1 className="banner-font text-white xl:pt-24 lg:pt-4 font-extrabold xl:text-head1 lg:text-head1 headlineheight md:text-head1 text-head1 md:text-xl text-2xl">
                  {" "}
                  {t("foodcontent1")}
                </h1>
                <p className="pt-2 xl:pt-2 text-white xl:mb-22 lg:mb-12 banner-font xl:text-lg text-lg">
                  {" "}
                  {t("foodcontent2")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        style={{
          backgroundColor: "rgb(0 149 207 / 7%)",
          width: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container mx-auto overflow-hidden px-4 xl:py-16 xl:px-12 md:py-12 py-6">
          <h1 className="uppercase banner-font font-extrabold text-black pt-1 xl:text-product text-left xl:px-12">
            {t("foodcontent3")}{" "}
            <span className="text-md font-bold">{t("foodcontent4")}</span>
          </h1>
          <div className="grid lg:grid-cols-4 md:grid-cols-3 gap-2 grid-cols-1 xl:mt-4 xl:px-12 lg:px-0 md:px-0 mt-8">
            <div className="team-memberport cursor-pointer center-items grid-item">
              <div className="team-memberport-inner bg-white shadow-lg">
                <img
                  alt="Your browser does not support this image"
                  src={daurade}
                  className="team-memberport-image border py-20 lg:py-20 md:py-16 xl:py-20"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font font-semibold text-white xl:text-para">
                    {t("foodcontent5")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent6")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent4")}
                  </h1>
                  <p className="banner-font text-black font-semibold text-sm">
                    {t("foodcontent7")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>

            <div className="team-memberport cursor-pointer center-items grid-item">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={maigre}
                  className="team-memberport-image border py-20 lg:py-20 md:py-16 xl:py-20"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font font-semibold text-white xl:text-para">
                    {t("foodcontent8")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent9")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent4")}
                  </h1>
                  <p className="banner-font text-black font-semibold text-sm">
                    {t("foodcontent10")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>

            <div className="team-memberport cursor-pointer center-items grid-item">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={bluefingg}
                  className="team-memberport-image border py-0 lg:py-1 md:py-2 xl:py-5"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font font-semibold text-white xl:text-para">
                    {t("foodcontent11")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent12")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent4")}
                  </h1>
                  <p className="banner-font text-black font-semibold text-sm s pb-1">
                    {t("foodcontent13")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>

            <div className="team-memberport cursor-pointer center-items grid-item">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={bluefinggloins}
                  className="team-memberport-image border py-0 lg:py-2 xl:py-5"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font font-semibold text-white xl:text-para">
                    {t("foodcontent14")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent15")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent4")}
                  </h1>
                  <p className="banner-font text-black font-semibold xl:text-sm lg:text-xs md:text-xs pb-1">
                    {t("foodcontent16")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>

            {/* 5 fish  */}
            {/* <div className="team-memberport cursor-pointer center-items">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={loup}
                  className="team-memberport-image border py-16 lg:py-20 md:py-14 xl:py-20"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("foodcontent17")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent18")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent4")}
                  </h1>
                  <p className="banner-font text-black font-semibold text-sm">
                    {t("foodcontent10")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div> */}

            {/* 6 fish  */}
            <div className="team-memberport cursor-pointer center-items">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={mottledgrouper3}
                  className="team-memberport-image border py-0 lg:py-2 xl:py-5"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("foodcontent19")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent20")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent4")}
                  </h1>
                  <p className="banner-font text-black font-semibold text-sm pb-1">
                    {t("foodcontent21")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>
          </div>

          <h1 className="uppercase banner-font text-black xl:pt-12 lg:pt-12 pt-8 xl:text-product text-left xl:px-12 font-extrabold">
            {t("foodcontent22")}{" "}
            <span className="text-md font-bold">{t("foodcontent23")} </span>
          </h1>
          <section className="grid lg:grid-cols-4 md:grid-cols-3 gap-2 grid-cols-1 xl:mt-4 xl:px-12 lg:px-0 md:px-0 mt-8">
            {/* 1 fish  */}
            <div className="team-memberport cursor-pointer center-items">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={scorpion}
                  className="team-memberport-image border py-20 lg:py-20 md:py-16 xl:py-24"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("foodcontent24")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent25")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent26")}
                  </h1>
                  <p className="banner-font text-black font-semibold xl:text-sm lg:text-xs md:text-xs pb-1">
                    {t("foodcontent27")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>

            {/* 2 fish  */}
            <div className="team-memberport cursor-pointer center-items">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={spottedshark}
                  className="team-memberport-image border py-10  lg:py-7 md:py-5 xl:py-14"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font font-semibold text-white xl:text-para">
                    {t("foodcontent28")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent29")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent23")}
                  </h1>
                  <p className="banner-font text-black font-semibold xl:text-sm lg:text-xs md:text-xs pb-1">
                    {t("foodcontent30")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>

            {/* 3 fish  */}
            <div className="team-memberport cursor-pointer center-items">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={redmullet}
                  className="team-memberport-image border py-16 lg:py-13 md:py-12 xl:py-20"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font font-semibold text-white xl:text-para">
                    {t("foodcontent31")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent32")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent23")}
                  </h1>
                  <p className="banner-font text-black font-semibold text-sm">
                    {t("foodcontent33")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>

            {/* 4 fish  */}
            <div className="team-memberport cursor-pointer center-items">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={pargo}
                  className="team-memberport-image border py-4 lg:py-1 xl:py-7"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font font-semibold text-white xl:text-para">
                    {t("foodcontent34")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent34")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent23")}
                  </h1>
                  <p className="banner-font text-black font-semibold text-sm">
                    {t("foodcontent36")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>

            {/* 9 fish  */}
            <div className="team-memberport cursor-pointer center-items">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={scorpaena}
                  className="team-memberport-image border py-20 lg:py-20 md:py-13 xl:py-21"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font font-semibold text-white xl:text-para">
                    {t("foodcontent37")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent38")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent23")}
                  </h1>
                  <p className="banner-font text-black font-semibold xl:text-sm lg:text-xs md:text-xs pb-1">
                    {t("foodcontent39")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>

            {/* 11 fish  */}
            <div className="team-memberport cursor-pointer center-items">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={mero}
                  className="team-memberport-image border py-10  lg:py-11 md:py-8 xl:py-16"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font font-semibold text-white xl:text-para">
                    {t("foodcontent40")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent41")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent23")}
                  </h1>
                  <p className="banner-font text-black font-semibold xl:text-sm lg:text-xs md:text-sm pb-1">
                    {t("foodcontent42")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>

            {/* 15 fish  */}
            <div className="team-memberport cursor-pointer center-items">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={bonito1}
                  className="team-memberport-image border py-20 lg:py-20 md:py-15 xl:py-21"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font font-semibold text-white xl:text-para">
                    {t("foodcontent43")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent44")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent23")}
                  </h1>
                  <p className="banner-font text-black font-semibold text-sm">
                    {t("foodcontent45")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>

            {/* 16 fish  */}
            <div className="team-memberport cursor-pointer center-items">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={swordfish}
                  className="team-memberport-image border py-10  lg:py-9 md:py-8 xl:py-13"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font font-semibold text-white xl:text-para">
                    {t("foodcontent46")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent47")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent23")}
                  </h1>
                  <p className="banner-font text-black font-semibold text-sm">
                    {t("foodcontent48")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>

            {/* 17 fish  */}
            <div className="team-memberport cursor-pointer center-items">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={pilchard}
                  className="team-memberport-image border py-0 lg:py-6 xl:py-5"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("foodcontent49")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent50")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent23")}
                  </h1>
                  <p className="banner-font text-black font-semibold text-sm">
                    {t("foodcontent51")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>

            {/* 18 fish  */}
            <div className="team-memberport cursor-pointer center-items">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={whitegrouper1}
                  className="team-memberport-image border py-0 lg:py-6 xl:py-5"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("foodcontent52")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent53")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent23")}
                  </h1>
                  <p className="banner-font text-black font-semibold text-sm">
                    {t("foodcontent54")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>

            {/* 19 fish  */}
            <div className="team-memberport cursor-pointer center-items">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={greymullet}
                  className="team-memberport-image border py-10  lg:py-20 md:py-10 xl:py-16"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("foodcontent55")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent56")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent23")}
                  </h1>
                  <p className="banner-font text-black font-semibold text-sm">
                    {t("foodcontent57")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>

            {/* 20 fish  */}
            <div className="team-memberport cursor-pointer center-items">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={thon}
                  className="team-memberport-image border py-10  lg:py-14 md:py-8 xl:py-13"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("foodcontent58")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent59")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent23")}
                  </h1>
                  <p className="banner-font text-black font-semibold text-sm">
                    {t("foodcontent60")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section id="cephalapodes">
            <h1 className="uppercase banner-font text-black xl:pt-12 lg:pt-12 pt-8 xl:text-product text-left xl:px-12 font-extrabold">
              {t("foodcontent61")}{" "}
              <span className="text-md font-bold">{t("foodcontent62")}</span>
            </h1>
            <div className="grid lg:grid-cols-4 md:grid-cols-3 gap-2 grid-cols-1 xl:mt-4 xl:px-12 lg:px-0 md:px-0 mt-8">
              <div className="team-memberport cursor-pointer center-items">
                <div className="team-memberport-inner bg-white">
                  <img
                    alt="Your browser does not support this image"
                    src={octopus}
                    className="team-memberport-image border py-10  lg:py-6 xl:py-4"
                  />
                  <div className="team-memberport-info">
                    <h1 className="banner-font text-white font-semibold xl:text-para">
                      {t("foodcontent63")}
                    </h1>
                    <h1 className="banner-font text-white xl:text-para">
                      {t("foodcontent64")}
                    </h1>
                  </div>
                </div>
                <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                  <div className="bg-redd radius xl:p-4 p-4" />
                  <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                    <h1 className="text-md  banner-font xl:text-para">
                      {t("foodcontent62")}
                    </h1>
                    <p className="banner-font text-black font-semibold text-sm">
                      {t("foodcontent65")}
                    </p>
                  </div>
                  <div className="pr-2">
                    <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                      →
                    </p>
                  </div>
                </div>
              </div>

              {/* Eight fish  */}
              <div className="team-memberport cursor-pointer center-items">
                <div className="team-memberport-inner bg-white">
                  <img
                    alt="Your browser does not support this image"
                    src={cuttlefish}
                    className="team-memberport-image border py-4 lg:py-6 xl:py-4"
                  />
                  <div className="team-memberport-info">
                    <h1 className="banner-font font-semibold text-white xl:text-para">
                      {t("foodcontent66")}
                    </h1>
                    <h1 className="banner-font text-white xl:text-para">
                      {t("foodcontent67")}
                    </h1>
                  </div>
                </div>
                <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                  <div className="bg-redd radius xl:p-4 p-4" />
                  <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                    <h1 className="text-md  banner-font xl:text-para">
                      {t("foodcontent62")}
                    </h1>
                    <p className="banner-font text-black font-semibold text-sm">
                      {t("foodcontent68")}
                    </p>
                  </div>
                  <div className="pr-2">
                    <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                      →
                    </p>
                  </div>
                </div>
              </div>

              {/* 12 fish  */}
              <div className="team-memberport cursor-pointer center-items">
                <div className="team-memberport-inner bg-white">
                  <img
                    alt="Your browser does not support this image"
                    src={squid}
                    className="team-memberport-image border py-4 lg:py-6 xl:py-4"
                  />
                  <div className="team-memberport-info">
                    <h1 className="banner-font font-semibold text-white xl:text-para">
                      {t("foodcontent69")}
                    </h1>
                    <h1 className="banner-font text-white xl:text-para">
                      {t("foodcontent70")}
                    </h1>
                  </div>
                </div>
                <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                  <div className="bg-redd radius xl:p-4 p-4" />
                  <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                    <h1 className="text-md  banner-font xl:text-para">
                      {t("foodcontent62")}
                    </h1>
                    <p className="banner-font text-black font-semibold text-sm">
                      {t("foodcontent71")}
                    </p>
                  </div>
                  <div className="pr-2">
                    <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                      →
                    </p>
                  </div>
                </div>
              </div>

              {/* 10 fish  */}
              <div className="team-memberport cursor-pointer center-items">
                <div className="team-memberport-inner bg-white">
                  <img
                    alt="Your browser does not support this image"
                    src={squid1}
                    className="team-memberport-image border py-0 lg:py-6 xl:py-4"
                  />
                  <div className="team-memberport-info">
                    <h1 className="banner-font font-semibold text-white xl:text-para">
                      {t("foodcontent72")}
                    </h1>
                    <h1 className="banner-font text-white xl:text-para">
                      {t("foodcontent73")}
                    </h1>
                  </div>
                </div>
                <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                  <div className="bg-redd radius xl:p-4 p-4" />
                  <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                    <h1 className="text-md  banner-font xl:text-para">
                      {t("foodcontent62")}
                    </h1>
                    <p className="banner-font text-black font-semibold text-sm">
                      {t("foodcontent71")}
                    </p>
                  </div>
                  <div className="pr-2">
                    <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                      →
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <h1 className="uppercase banner-font text-black xl:pt-12 lg:pt-12 pt-8 xl:text-product text-left xl:px-12 font-extrabold">
            {t("foodcontent61")}{" "}
            <span className="text-md font-bold">{t("foodcontent74")}</span>
          </h1>
          <div className="grid lg:grid-cols-4 md:grid-cols-3 gap-2 grid-cols-1 xl:mt-4 xl:px-12 lg:px-0 md:px-0 mt-8">
            {/* 23 fish  */}

            <div className="team-memberport cursor-pointer center-items">
              <div className="team-memberport-inner bg-white">
                <img
                  alt="Your browser does not support this image"
                  src={shrimp1}
                  className="team-memberport-image border py-0 lg:py-6 xl:py-5"
                />
                <div className="team-memberport-info">
                  <h1 className="banner-font text-white font-semibold xl:text-para">
                    {t("foodcontent75")}
                  </h1>
                  <h1 className="banner-font text-white xl:text-para">
                    {t("foodcontent76")}
                  </h1>
                </div>
              </div>
              <div className="bg-white flex z-2 xl:-mt-12 lg:-mt-10 md:-mt-10 -mt-10 radius shadow-lg xl:mb-4 md:mb-4 border-darkblue text-left">
                <div className="bg-redd radius xl:p-4 p-4" />
                <div className="xl:p-4 p-4 xl:w-40 lg:w-36 md:w-36 w-60">
                  <h1 className="text-md  banner-font xl:text-para">
                    {t("foodcontent74")}
                  </h1>
                  <p className="banner-font text-black font-semibold xl:text-sm lg:text-xs md:text-sm pb-1">
                    {t("foodcontent77")}
                  </p>
                </div>
                <div className="pr-2">
                  <p className="bg-redd py-2 px-3 xl:mt-6 mt-5 text-white rounded-full">
                    →
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <FooterSmallNew />
    </section>
  );
};
export default FoodMenu;
